import React, {useState} from "react";
import {Space, Tag, Form} from "antd";
import {Form as MobileForm} from 'antd-mobile';
import {FormInstance as MobileFormInstance} from "antd-mobile/es/components/form/form";
import PcComponentWrapper from "@/components/PcComponentWrapper";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import MobileOrganizationSelectList from "@/page-components/detail/Intro/OrganizationSelect/mobile_select";
import {TOrganizationPeople} from "@/types/exam_signup";
import TableTransfer from "@/page-components/detail/Intro/OrganizationSelect/table_transfer";
import styles from 'src/page-components/detail/Intro/styles.module.less';
import { FormInstance } from "antd/lib/form/hooks/useForm";

type TOrganizationPeopleSelect = {
    form:FormInstance,
  certId: string;
  mobileFormInstance?: MobileFormInstance;
  onChange: (selectKey: string[]) => void;
}

const OrganizationPeopleSelect:React.FC<TOrganizationPeopleSelect> = ({certId,mobileFormInstance,onChange,form}) => {
  const [pcSelectUser, setPcSelectUser] = useState<string[]>([]);
  const [selectUser, setSelectUser] = useState<TOrganizationPeople[]>([]);
  return (
    <>
      <MobileComponentWrapper>
        <div className={styles.organization_people_wrapper}>
          <div className={styles.organization_people_wrapper_header}>
            <Space className={styles.header_require} size={0}>
              <span className="adm-form-item-label-required">*</span>报名人员
            </Space>
            <p className={styles.header_tips}>已过滤已报名/已通过人员</p>
            <MobileForm.Item className={styles.row} name="select_user" rules={[{ required: true,message:'请选择考试人员' }]}>
              <MobileOrganizationSelectList
                certId={certId}
                selectUser={selectUser}
                onSubmit={data => {
                  console.log('onSubmit');
                  console.log(data);
                  onChange(data.map(item => String(item.id)));
                  setSelectUser(data);
                }}
              />
            </MobileForm.Item>
          </div>
          <div className={styles.organization_people_wrapper_body}>
            {selectUser.map(user => {
              return (
                <Tag closable className={styles.remove_tag_wrapper} key={user.id} onClose={(e) => {
                  console.log('change');
                  const idx = selectUser.findIndex(item => item.id === user.id);
                  console.log(idx);
                  if (idx > -1){
                    setSelectUser(prev => {
                      prev.splice(idx,1);
                      onChange(prev.map(item => String(item.id)));
                      if (mobileFormInstance){
                        mobileFormInstance.setFieldsValue({select_user: prev})
                      }
                      return [...prev];
                    })
                  }
                }}>
                  {user.realname !== null ? user.realname : user.username}
                </Tag>
              )
            })}
          </div>
        </div>
      </MobileComponentWrapper>
      <PcComponentWrapper>
        <Form.Item
            className={styles.row}
            name="select_user"
            label={<span className={styles.tips_text}>报考人员：</span>}
            rules={[{ required: true,message:'请选择考试人员' }]}>
            <span className={styles.small_tips_text}>不展示已报名和已通过人员</span>
                <TableTransfer
                    certId={certId}
                    targetKeys={pcSelectUser}
                    setTargetKeys={(keys:any[]) => {
                        setPcSelectUser(keys)
                        form.setFieldValue("select_user",keys)
                        onChange(keys)
                    }}
                />
        </Form.Item>
      </PcComponentWrapper>
    </>
  )
}
export default OrganizationPeopleSelect;
